<script setup>
defineProps(['avatar', 'color'])
</script>

<template>
<v-avatar :color="color" size="32">
    {{ avatar }}
  </v-avatar>
</template>